import { MODAL_MAX_WIDTH } from 'src/navigation/consts/NavigationHelper'

export const ROUTER_CONTENT_PADDING_WEB = 10
export const ROUTER_CONTENT_MAX_WIDTH = MODAL_MAX_WIDTH - ROUTER_CONTENT_PADDING_WEB
